<div class="popupContent">
  <span style="font-size: 14px">Deleted and Replaced Items </span>
  <div class="mt20">
    <div id='nonStyleHiddenHeaderGrid'>
    <kendo-grid [scrollable]="'none'"  [kendoGridBinding]="eplObseluteData"
      [selectable]="{ checkboxOnly: true }" (selectionChange)="OnSelectionChangeEvent($event, 'obseluteGrid')">
      <ng-template kendoGridHeaderTemplate> <!-- Empty template to hide header --> </ng-template>
      <kendo-grid-checkbox-column [width]="40"></kendo-grid-checkbox-column>
      <kendo-grid-column field="deletedItem" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [innerHTML]="dataItem.deletedItem">
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="replacedItem" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [innerHTML]="dataItem.replacedItem">
          </span>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
    <button class="button-undo" (click)="undoObselute()">Undo</button>
  </div>
  </div>
</div>